export const INVOICES_SLICE_NAME = "invoices"
